import ProductDescription from './ProductDescription'

const PlantCheeseProduct = {
  ...ProductDescription,
  category: '00',
  subCategory: '002',
  IsBroadband: false,
  Calcium: '',
  CalciumCertification: false,
  Protein: '',
  ProteinCertification: false,
  PlantCheeseAltType: '',
  OtherPlantCheeseAltType: null,
  Type: '',
  OtherType: null,
  Form: '',
  Size: '',
}

export default PlantCheeseProduct
